import { filter, Observable, take, takeUntil } from 'rxjs';
import { ModalService } from '../shared/services/modal/modal.service';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { ConfirmModalComponent, ConfirmModalData, ConfirmModalResult } from '../shared/modals/confirm-modal/confirm-modal.component';
import { SuccessModalComponent, SuccessModalData } from '../shared/modals/success-modal/success-modal.component';
import { ButtonTypeEnum } from '../shared/components/button/types/button-type.enum';

export function openConfirmModal(
  modalService: ModalService,
  modalWidth: string,
  modalData: ConfirmModalData,
  onConfirm?: () => void | Promise<void>,
  destroy$?: Observable<void>,
): DynamicDialogRef {
  const ref = modalService.confirm(ConfirmModalComponent, {
    width: modalWidth,
    modal: true,
    closable: false,
    showHeader: false,
    data: modalData,
  });

  const close$ = ref.onClose.pipe(
    filter((result?: ConfirmModalResult) => result?.actionId === 'confirm'),
  );

  (destroy$ ? close$.pipe(takeUntil(destroy$)) : close$)
    .pipe(take(1))
    .subscribe(() => {
      void Promise.resolve(onConfirm?.());
    });

  return ref;
}

export function openSuccessModal(
  modalService: ModalService,
  modalWidth: string,
  modalData?: SuccessModalData,
  onClose?: () => void | Promise<void>,
  destroy$?: Observable<void>,
): DynamicDialogRef {
  const ref = modalService.open(SuccessModalComponent, {
    width: modalWidth,
    modal: true,
    closable: false,
    showHeader: false,
    data: modalData,
  });

  const close$ = ref.onClose.pipe(take(1));

  (destroy$ ? close$.pipe(takeUntil(destroy$)) : close$)
    .subscribe(() => {
      onClose?.();
    });

  return ref;
}

export function createCancelConfirmButtons(
  confirmLabel: string,
  confirmType: ButtonTypeEnum = ButtonTypeEnum.PRIMARY,
): ConfirmModalData['buttons'] {
  return [
    {
      id: 'cancel',
      label: 'Cancelar',
      type: ButtonTypeEnum.OUTLINE,
      outline: true,
    },
    {
      id: 'confirm',
      label: confirmLabel,
      type: confirmType,
    },
  ];
}
